import React from "react";

import { Text } from "@performyard/py-components";
import { toFixed } from "@performyard/utils-isomorphic";

import type { DecisionRow } from "../../../types";

import { formatCurrencyFull } from "../../../utils";

export const ApprovedBudgetLine = ({ actorName }: { actorName: string | null }): React.ReactElement => (
	<span className="inline whitespace-nowrap">
		<Text overrideElement="span" size="paragraph-3" weight="semi-bold" color="neutral-9">
			{actorName ?? "Budget approver"}
		</Text>
		<Text overrideElement="span" size="paragraph-3" weight="regular" color="neutral-7">
			{" approved "}
		</Text>
		<Text overrideElement="span" size="paragraph-3" weight="regular" color="neutral-9">
			budget.
		</Text>
	</span>
);

export const SubmittedBudgetLine = ({ actorName }: { actorName: string | null }): React.ReactElement => (
	<span className="inline whitespace-nowrap">
		<Text overrideElement="span" size="paragraph-3" weight="semi-bold" color="neutral-9">
			{actorName}
		</Text>
		<Text overrideElement="span" size="paragraph-3" weight="regular" color="neutral-7">
			{" submitted "}
		</Text>
		<Text overrideElement="span" size="paragraph-3" weight="regular" color="neutral-9">
			budget.
		</Text>
	</span>
);

export const EditedSalaryLine = ({
	actorName,
	employeeName,
	increased,
	amount,
	percent,
}: {
	actorName: string | null;
	employeeName: string | null;
	increased: boolean;
	amount: number | null;
	percent: number | null;
}): React.ReactElement => (
	<span className="inline whitespace-nowrap">
		<Text overrideElement="span" size="paragraph-3" weight="semi-bold" color="neutral-9">
			{actorName ?? "Cycle owner"}
		</Text>
		<Text overrideElement="span" size="paragraph-3" weight="regular" color={increased ? "green-5" : "red-5"}>
			{increased ? " increased " : " decreased "}
		</Text>
		<Text overrideElement="span" size="paragraph-3" weight="regular" color="neutral-9">
			{employeeName ?? "employee"}
			{"'s salary to "}
			{amount == null ? "—" : formatCurrencyFull(amount)} ({percent}%)
		</Text>
	</span>
);

export const SalaryUpdateLine = ({
	user,
	actorName,
}: {
	user: DecisionRow;
	actorName: string | null;
}): React.ReactElement => (
	<span className="inline whitespace-nowrap">
		<Text overrideElement="span" size="paragraph-3" weight="semi-bold" color="neutral-9">
			{actorName}
		</Text>
		<Text overrideElement="span" size="paragraph-3" weight="regular" color="neutral-7">
			{" set "}
		</Text>
		<Text overrideElement="span" size="paragraph-3" weight="regular" color="neutral-9">
			{user.employee_name} salary to{" "}
			{user.proposed_increase_amount == null ? "—" : formatCurrencyFull(user?.proposed_salary || 0)} (
			{toFixed(user.proposed_increase_percent ?? 0, 2)}%)
		</Text>
	</span>
);
